<div class="dialog-footer" [ngClass]="{ rounded: rounded() }">
  <ng-content class="left-addon" select="[left-addon]" />
  <ng-content class="right-addon" select="[right-addon]" />
</div>
